export const messagesForEvacuation = {
  "Evacuation Order": {
      "scenario_title": {
          "EN": "Evacuation Order",
          "ES": "Orden de evacuación",
          "MAND": "疏散命令"
      },
      "source_agency": "Marin Wildfire Prevention Authority",
      "message": {
          "EN": "An immediate evacuation is required due to wildfire circumstances.",
          "ES": "Se requiere una evacuación inmediata debido a las circunstancias del incendio forestal.",
          "MAND": "由于野火情况，需要立即撤离。"
      },
      "impact": {
          "EN": "Failure to evacuate could prevent firefighters from accessing the area, risking lives and increasing property damage.",
          "ES": "No evacuar podría impedir que los bomberos accedan al área, poniendo en riesgo vidas y aumentando los daños a la propiedad.",
          "MAND": "未能撤离可能会阻止消防员进入该区域，危及生命并增加财产损失。"
      },
      "nudge": {
          "EN": "Next steps: Save your life and protect your property by leaving immediately. Time is of the essence!",
          "ES": "Próximos pasos: Salve su vida y proteja su propiedad saliendo de inmediato. ¡El tiempo es esencial!",
          "MAND": "下一步：立即撤离以保护您的生命和财产。时间至关重要！"
      },
      "utilized_biases_list": ["Aversion to loss bias", "Urgency and Scarcity effect"]
  },
  "Evacuation Warning": {
      "scenario_title": {
          "EN": "Evacuation Warning",
          "ES": "Advertencia de evacuación",
          "MAND": "疏散警告"
      },
      "source_agency": "Marin Wildfire Prevention Authority",
      "message": {
          "EN": "Be prepared to evacuate. If needing assistance or living in challenging areas, leave early.",
          "ES": "Prepárense para evacuar. Si necesita asistencia o vive en áreas difíciles, salga temprano.",
          "MAND": "准备好撤离。如果需要帮助或生活在困难区域，请提前离开。"
      },
      "impact": {
          "EN": "Being ready to evacuate helps protect lives and facilitates emergency responder access.",
          "ES": "Estar preparado para evacuar ayuda a proteger vidas y facilita el acceso a los socorristas de emergencia.",
          "MAND": "做好撤离准备有助于保护生命并便利紧急响应人员进入。"
      },
      "nudge": {
          "EN": "Next steps: Act now to ensure your safety and protect your belongings. Early action makes a big difference!",
          "ES": "Próximos pasos: Actúe ahora para asegurar su seguridad y proteger sus pertenencias. ¡La acción anticipada hace una gran diferencia!",
          "MAND": "下一步：立即行动以确保安全并保护您的物品。早行动意义重大！"
      },
      "utilized_biases_list": ["Urgency and Scarcity effect", "Framing effect"]
  },
  "Shelter in Place": {
      "scenario_title": {
          "EN": "Shelter in Place",
          "ES": "Refugio en el lugar",
          "MAND": "就地避难"
      },
      "source_agency": "Marin Wildfire Prevention Authority",
      "message": {
          "EN": "Go indoors until further notice.",
          "ES": "Vaya adentro hasta nuevo aviso.",
          "MAND": "进入室内，直到另行通知。"
        },
      "impact": {
          "EN": "Sheltering protects you from smoke and heat while emergency services address the situation.",
          "ES": "Refugiarse lo protege del humo y el calor mientras los servicios de emergencia se ocupan de la situación.",
          "MAND": "避难可以保护您免受烟雾和高温影响，同时应急服务正在处理情况。"
      },
      "nudge": {
          "EN": "Next steps: Stay safe indoors to minimize exposure. Every precaution counts!",
          "ES": "Próximos pasos: Manténgase seguro adentro para minimizar la exposición. ¡Cada precaución cuenta!",
          "MAND": "下一步：待在室内以减少暴露风险。每项预防措施都很重要！"
      },
      "utilized_biases_list": ["Status quo (Default) bias"]
  },
  "Red Flag Day": {
      "scenario_title": {
          "EN": "Red Flag Day",
          "ES": "Día de bandera roja",
          "MAND": "红旗日"
      },
      "source_agency": "Marin Wildfire Prevention Authority",
      "message": {
          "EN": "Wildfire conditions are extreme. Maintain heightened awareness.",
          "ES": "Las condiciones de incendio forestal son extremas. Manténgase alerta.",
          "MAND": "野火条件极端。保持高度警惕。"
      },
      "impact": {
          "EN": "Increased vigilance can help prevent accidental fires and allow quick reaction to threats.",
          "ES": "La mayor vigilancia puede ayudar a prevenir incendios accidentales y permitir una reacción rápida a las amenazas.",
          "MAND": "提高警惕可以帮助防止意外火灾并快速应对威胁。"
      },
      "nudge": {
          "EN": "Next steps: Be watchful and proactive to protect your community. Acting fast saves lives!",
          "ES": "Próximos pasos: Esté atento y proactivo para proteger su comunidad. ¡Actuar rápido salva vidas!",
          "MAND": "下一步：保持警惕并采取积极行动以保护您的社区。快速行动能挽救生命！"
      },
      "utilized_biases_list": ["Aversion to loss bias", "Framing effect"]
  },
  "Fire Roads": {
      "scenario_title": {
          "EN": "Avoid Fire Road",
          "ES": "Salga de la carretera de incendios",
          "MAND": "避免火路"
      },
      "source_agency": "Marin Wildfire Prevention Authority",
      "message": {
          "EN": "Fire roads are dangerous. Avoid them to ensure your safety.",
          "ES": "Las carreteras de incendio son peligrosas. Evítelas para asegurar su seguridad.",
          "MAND": "火路危险。请避免以确保安全。"
      },
      "impact": {
          "EN": "Staying off fire roads ensures they remain clear for firefighter access, reducing risk and loss.",
          "ES": "Mantenerse fuera de las carreteras de incendios asegura que permanezcan despejadas para el acceso de los bomberos, reduciendo riesgos y pérdidas.",
          "MAND": "避免使用火路可确保其畅通，便于消防员进入，降低风险和损失。"
      },
      "nudge": {
          "EN": "Next steps: Help the heroes save homes by keeping fire roads clear. Your actions matter!",
          "ES": "Próximos pasos: Ayude a los héroes a salvar hogares manteniendo despejadas las carreteras de incendios. ¡Tus acciones importan!",
          "MAND": "下一步：保持火路畅通以帮助英雄们拯救家园。您的行动至关重要！"
      },
      "utilized_biases_list": ["Status quo (Default) bias", "Framing effect"]
  },
  "Uphill": {
      "scenario_title": {
          "EN": "Go Downhill",
          "ES": "Baja la colina",
          "MAND": "下山"
      },
      "source_agency": "Marin Wildfire Prevention Authority",
      "message": {
          "EN": "Move downhill for safety during a wildfire.",
          "ES": "Descienda para estar seguro durante un incendio forestal.",
          "MAND": "在野火期间，下山以确保安全。"
      },
      "impact": {
          "EN": "Moving downhill reduces danger and increases protection from flames.",
          "ES": "Moverse cuesta abajo reduce el peligro y aumenta la protección contra las llamas.",
          "MAND": "下山可以降低危险并增强对火焰的保护。"
      },
      "nudge": {
          "EN": "Next steps: Seek lower ground. It's crucial for safeguarding yourself!",
          "ES": "Próximos pasos: Busque terreno más bajo. ¡Es crucial para protegerse!",
          "MAND": "下一步：寻找较低的地方。这对保护自己至关重要！"
      },
      "utilized_biases_list": ["Aversion to loss bias"]
  },
  "In-turn Risk": {
      "scenario_title": {
          "EN": "In-turn Risk",
          "ES": "Riesgo en la curva",
          "MAND": "转弯风险"
      },
      "source_agency": "Marin Wildfire Prevention Authority",
      "message": {
          "EN": "Wildfire risk is greater at turns. Leave quickly to minimize danger.",
          "ES": "El riesgo de incendio forestal es mayor en las curvas. Salga rápidamente para minimizar el peligro.",
          "MAND": "在转弯处野火风险更大。迅速离开以尽量减少危险。"
      },
      "impact": {
          "EN": "Quickly leaving turns helps protect your life and ensures safety from the spreading fire.",
          "ES": "Salir rápidamente de las curvas ayuda a proteger su vida y asegura la seguridad frente al fuego que se propaga.",
          "MAND": "迅速离开转弯处有助于保护生命，并确保免受蔓延的火灾威胁。"
      },
      "nudge": {
          "EN": "Next steps: Act fast to stay safe and secure your surroundings from wildfire threats.",
          "ES": "Próximos pasos: Actúe rápido para mantenerse seguro y proteger su entorno de las amenazas de incendio forestal.",
          "MAND": "下一步：迅速行动以确保安全，并保护周围环境免受野火威胁。"
      },
      "utilized_biases_list": ["Urgency and Scarcity effect", "Framing effect"]
  },
  "Paved Roads": {
      "scenario_title": {
          "EN": "Get to Paved Roads",
          "ES": "Llegar a Carreteras Pavimentadas",
          "MAND": "到达铺好的道路"
      },
      "source_agency": "Marin Wildfire Prevention Authority",
      "message": {
          "EN": "Ensure your route is on paved roads. They are safer for evacuating vehicles.",
          "ES": "Asegúrese de que su ruta esté en carreteras pavimentadas. Son más seguras para vehículos en evacuación.",
          "MAND": "确保您的路线在铺好的道路上。它们对疏散车辆更安全。"
      },
      "impact": {
          "EN": "Using unpaved roads can delay evacuations and put lives at risk. Stay on paved routes to ensure safe passage.",
          "ES": "Usar carreteras sin pavimentar puede retrasar las evacuaciones y poner vidas en riesgo. Permanezca en rutas pavimentadas para garantizar un paso seguro.",
          "MAND": "使用未铺砌的道路可能会延迟疏散并危及生命。在铺好的路线上确保安全通行。"
      },
      "nudge": {
          "EN": "Evacuate now via paved roads to avoid losses. Your safety is our priority.",
          "ES": "Evacúe ahora por carreteras pavimentadas para evitar pérdidas. Su seguridad es nuestra prioridad.",
          "MAND": "现在通过铺好的道路疏散以避免损失。您的安全是我们的首要任务。"
      },
      "utilized_biases": ["Aversion to loss bias", "Urgency and Scarcity effect", "Framing effect"]
  },
  "Stay in car": {
      "scenario_title": {
          "EN": "Stay in Car",
          "ES": "Quédate en el Auto",
          "MAND": "留在车里"
      },
      "source_agency": "Marin Wildfire Prevention Authority",
      "message": {
          "EN": "During a wildfire, your car offers greater safety than evacuating on foot.",
          "ES": "Durante un incendio forestal, su automóvil ofrece mayor seguridad que evacuar a pie.",
          "MAND": "在野火期间，您的车比徒步疏散更安全。"
      },
      "impact": {
          "EN": "Leaving your vehicle can expose you to greater danger from smoke and flames. Stay inside your car to increase protection.",
          "ES": "Salir de su vehículo puede exponerlo a un mayor peligro por el humo y las llamas. Permanezca dentro de su auto para aumentar la protección.",
          "MAND": "离开车辆可能会让您暴露在烟雾和火焰的更大危险中。留在车内增加保护。"
      },
      "nudge": {
          "EN": "Remain in your car until firefighters guide you to safety. Prioritize your life over property.",
          "ES": "Permanezca en su auto hasta que los bomberos lo guíen a un lugar seguro. Priorice su vida sobre la propiedad.",
          "MAND": "留在车内，直到消防员引导您到安全的地方。优先考虑您的生命而不是财产。"
      },
      "utilized_biases": ["Status quo (Default) bias", "Urgency and Scarcity effect", "Aversion to loss bias"]
  },
  "Gas Shutoff and Tank Safety": {
  "scenario_title": {
      "EN": "Shut off Gas and Tank Safety",
      "ES": "Cierre del gas y seguridad de los tanques",
      "MAND": "关闭煤气和罐子安全"
  },
  "message": {
      "EN": "Shut off gas at the meter or propane tank & move small tanks at least 15’ away from combustibles.",
      "ES": "Cierre el gas en el medidor o tanque de propano & mueva los tanques pequeños al menos a 15 pies de los combustibles.",
      "MAND": "关闭煤气表或丙烷罐. 将小型罐子至少移到离可燃物15英尺的地方。"
  },
  "impact": {
      "EN": "Shutting off gas and moving tanks can prevent explosions or fires from igniting during the wildfire.",
      "ES": "Apagar el gas y mover los tanques puede prevenir explosiones o incendios durante el incendio forestal.",
      "MAND": "关闭煤气并移动罐子可以防止野火期间发生爆炸或火灾。"
  },
  "nudge": {
      "EN": "Next steps: Ensure gas is off and tanks are safely moved to protect yourself and others.",
      "ES": "Próximos pasos: Asegúrese de que el gas esté apagado y los tanques estén movidos de forma segura para protegerse a sí mismo y a los demás.",
      "MAND": "下一步：确保关闭煤气并安全移动罐子，以保护自己和他人。"
  },
  "utilized_biases_list": ["Aversion to loss bias", "Risk aversion"]
},

"Garden Hose Setup": {
  "scenario_title": {
      "EN": "Garden Hose Setup for Firefighters",
      "ES": "Instalación de manguera de jardín para los bomberos",
      "MAND": "为消防员设置花园软管"
  },
  "message": {
      "EN": "Connect garden hoses with squeeze-grip nozzles to outdoor spigots for use by firefighters.",
      "ES": "Conecte mangueras de jardín con boquillas de agarre a los grifos exteriores para el uso de los bomberos.",
      "MAND": "将带握把喷嘴的花园软管连接到户外水龙头，以供消防员使用。"
  },
  "impact": {
      "EN": "Having garden hoses ready ensures that firefighters have immediate access to water for firefighting.",
      "ES": "Tener las mangueras de jardín listas asegura que los bomberos tengan acceso inmediato al agua para combatir el fuego.",
      "MAND": "准备好花园软管可以确保消防员能够立即使用水源进行灭火。"
  },
  "nudge": {
      "EN": "Next steps: Set up hoses now to support firefighting efforts and help protect your home.",
      "ES": "Próximos pasos: Configure las mangueras ahora para apoyar los esfuerzos de extinción de incendios y proteger su hogar.",
      "MAND": "下一步：现在设置软管以支持灭火工作并帮助保护您的家园。"
  },
  "utilized_biases_list": ["Status quo (Default) bias", "Proactive behavior bias"]
},

"Water Buckets for Protection": {
  "scenario_title": {
      "EN": "Water Buckets for Protection",
      "ES": "Cubos de agua para protección",
      "MAND": "水桶保护"
  },
  "message": {
      "EN": "Fill water buckets and place around outside of house, especially near decks and fences.",
      "ES": "Llene cubos de agua y colóquelos alrededor de la casa, especialmente cerca de terrazas y cercas.",
      "MAND": "填满水桶并将其放置在房屋周围，尤其是靠近平台和围栏的地方。"
  },
  "impact": {
      "EN": "Placing water buckets around the house helps firefighters control flames and reduce fire spread.",
      "ES": "Colocar cubos de agua alrededor de la casa ayuda a los bomberos a controlar las llamas y reducir la propagación del fuego.",
      "MAND": "将水桶放置在房屋周围可以帮助消防员控制火焰并减少火灾蔓延。"
  },
  "nudge": {
      "EN": "Next steps: Place water buckets now to assist firefighters and protect your property.",
      "ES": "Próximos pasos: Coloque los cubos de agua ahora para ayudar a los bomberos y proteger su propiedad.",
      "MAND": "下一步：立即放置水桶以协助消防员并保护您的财产。"
  },
  "utilized_biases_list": ["Proactive behavior bias", "Status quo (Default) bias"]
  },
  "Check-in": {
      "scenario_title": {
      "EN": "Check-in",
      "ES": "Registrarse",
      "MAND": "签到"
      },
      "message": {
      "EN": "Have you safely evacuated?",
      "ES": "¿Te has evacuado con seguridad?",
      "MAND": "你已经安全撤离了吗？"
      }
  }
    
};